<script lang="ts">
	import { PathUtils } from '@core/tools/PathUtils';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import type { LinkListBlockType } from './LinkListBlockQuery';
	import LinkButton from '@comp/LinkButton.svelte';

	const { data }: { data: LinkListBlockType } = $props();

	createViewController();
</script>

<section id={PathUtils.slugify(data.headline)} use:ViewController>
	<div class="container" use:EnterOnView>
		<h1 class="text:headline-large" use:EnterOnView={{ delay: 0.05 }}>{data.headline}</h1>
		<div class="links text:description-large" use:EnterOnView={{ delay: 0.1 }}>
			{#each data.links as link}
				<span class="underline">
					<LinkButton {link} variant="link"></LinkButton>
				</span>
			{/each}
		</div>
	</div>
</section>

<style lang="scss">
	section {
		@include pagePadding;
		@include blockPadding;

		@include md {
			&:target {
				scroll-margin-top: 94px;
			}
		}
	}

	.container {
		border-top: $border;
		padding-top: 16px;

		@include layoutBlockGrid(false);
	}

	h1 {
		grid-column: 1 / -1;
		@include md {
			grid-column: 1 / span 5;
		}
	}

	.links {
		display:flex;
		padding-top: 30px;
		flex-direction: column;
		gap: 25px;
		align-items: start;

		grid-column: 1 / -1;

		@include md {
			grid-column: 6 / span 5;
			padding-top: 26px;
		}

		:global([data-button]) {
			&:hover {
				text-decoration: none;
			}
		}
	}
</style>
